import React from "react";
import Help from "../component/sections/ticket/Help";
import AllTickets from "../component/sections/ticket/AllTickets";
import AddTickets from "../component/sections/ticket/AddTickets";
import ViewTickets from "../component/sections/ticket/ViewTickets";

const ticketRoutes = [
  {
    path: "/ticket/view/:id",
    render: () => <ViewTickets />,
    exact: true,
  },
  {
    path: "/ticket/add",
    render: () => <AddTickets />,
    exact: true,
  },
  {
    path: "/tickets",
    render: () => <AllTickets />,
    exact: true,
  },
  {
    path: "/help",
    render: () => <Help />,
    exact: true,
  },
];

export default ticketRoutes;
